module.exports = __webpack_public_path__ + "images/quilty-subscription-tiers-basic.png";